if (typeof window.sizeGuide === 'undefined') {
    window.sizeGuide = function() {
        class SizeGuide extends HTMLElement {
            constructor() {
                super();

                this.popup = this;
                
                $(document).on('click', '[data-open-size-guide-popup]', (event) => {
                    this.loadNode();
                    this.setOpenPopup(event);
                });

                $(document).on('click', '[data-close-size-guide-popup]', (event) => {
                    this.setClosePopup(event);
                });

                document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
            }

            loadNode() {
                if (this.matches('.node-loaded')) return;
                this.classList.add('node-loaded');

                const urlStyleSG = this.dataset.urlStyleSizeGuide;
                if (urlStyleSG != '') {
                    const loadStyleSheet = document.createElement("link");
                    loadStyleSheet.rel = 'stylesheet';
                    loadStyleSheet.type = 'text/css';
                    loadStyleSheet.href = urlStyleSG;
                    this.parentNode.insertBefore(loadStyleSheet, this);
                }
            }

            setOpenPopup(event) {
                event.preventDefault();
                event.stopPropagation();

                document.body.classList.add('size-guide-show');
                if (document.body.classList.contains('quick-view-show')) {
                    $('.halo-popup-content .halo-size-guide-popup').addClass('is-show');
                }
                else {
                    $('#MainContent .halo-size-guide-popup').addClass('is-show');
                }
            }

            setClosePopup(event) {
                event.preventDefault();
                event.stopPropagation();

                document.body.classList.remove('size-guide-show');
                $('.halo-size-guide-popup').removeClass('is-show');
            }

            onBodyClickEvent(event) {
                if (document.body.classList.contains('size-guide-show')) {
                    if ((!this.contains(event.target)) && ($(event.target).closest('[data-open-size-guide-popup], .halo-popup-content').length === 0)) {
                        this.setClosePopup(event);
                    }
                }
            }
        }

        customElements.define('size-guide', SizeGuide);
    };

    // Always initialize Size Guide functionality
    window.sizeGuide();
}
